import{gql as e}from"@apollo/client";const r=e`
  query getPaginatedGroupsForUser($userId: Int!) {
    group {
      getPaginatedGroupsForUser: getGroupsForUser(userId: $userId) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;export{r as GET_PAGINATED_GROUPS_FOR_USER_QUERY};
//# sourceMappingURL=useGetPaginatedGroupsForUser.graphql.js.map
